import { render, staticRenderFns } from "./center-common.vue?vue&type=template&id=1036b524&scoped=true"
import script from "./center-common.vue?vue&type=script&lang=js"
export * from "./center-common.vue?vue&type=script&lang=js"
import style1 from "./center-common.vue?vue&type=style&index=1&id=1036b524&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036b524",
  null
  
)

export default component.exports